import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import { OrderModel } from '../../../models/order'
import { IMAGE_CUSTOMER } from '../../../lib/endpoints/customer'
import { findPhoneFromOrder } from '../../../utils/findPhoneFromOrder'
import { useTranslation } from 'react-i18next'
import { findOrderCreateTime } from '../../../utils/findOrderCreareTime'
import { numberFormat } from '../../../utils/nunberFormat'
import ShipmentMethodChip from '../../../components/ShipmentMethodChip'
import { ShipmentMethodEnum } from '../../../enums/shipmentMethod'
import PaymentMethodText from '../../../components/PaymentMethodText'
import { PaymentMethodEnum } from '../../../enums/paymentMethod'
import { convertDateStringToNormalDateTimeString } from '../../../utils/convertDateFormat'
import { calculateOrderProductUnitByCarts } from '../../../utils/calculateOrderProductUnitByCarts'

const CardCustomer = ({ selectedData }: { selectedData: OrderModel }) => {
    const { t } = useTranslation('global')
    return (
        <Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: 2,
                padding: 2,
                borderRadius: "16px",
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
            }}>
                <Avatar alt="Customer" src={IMAGE_CUSTOMER + selectedData?.customer?.profile?.image?.url} sx={{
                    width: '128px',
                    height: '128px'
                }} />
                <Typography sx={{
                    color: "var(--text-light-secondary, #637381)",
                    fontSize: '32px',
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "18px"
                }}>{selectedData?.customer?.profile?.fullName}</Typography>
                <Typography color="#616161">{t("order_page.Phone")}: <span style={{ color: 'red' }}>{findPhoneFromOrder(selectedData)}</span></Typography>
            </Box>
            <Typography color="#616161" fontSize="24px" sx={{ mt: 1, mb: 1 }}>{t("order_page.Order information")}</Typography>
            <Box sx={{
                gap: 2,
                padding: 2,
                borderRadius: "16px",
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
            }}>

                <Typography color="#616161">{t("order_page.Order time")}: <span style={{ fontWeight: 'bold' }}>{findOrderCreateTime(selectedData)}</span></Typography>
                <Typography color="#616161">{t("order_page.Order number")}: <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNumber}</span></Typography>
                <Typography color="#616161">{t("order_page.Order ID")}: <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNo}</span></Typography>
                <Typography color="#616161">{t("order_page.Price")}: <span style={{ fontWeight: 'bold' }}>{numberFormat(selectedData?.totoalWithDeliveryFee)}</span> {t("Kip")}</Typography>
                <Typography color="#616161">{t("order_page.Shipment method")}: <ShipmentMethodChip value={selectedData?.orderMethod as ShipmentMethodEnum} /></Typography>
                <Typography color="#616161">{t("order_page.Payment method")}: <PaymentMethodText paymentMethod={selectedData?.paymentMethod as PaymentMethodEnum} /></Typography>
                <Typography color="#616161">{t("order_page.Distance")}: <span style={{ fontWeight: 'bold' }}>{selectedData?.distance} {t("Km")}</span></Typography>
                <Typography color="#616161">{t("order_page.Delivery time")}: <b>{selectedData?.deliveryTime && convertDateStringToNormalDateTimeString(selectedData?.deliveryTime)}</b></Typography>
            </Box>
            <Box sx={{
                mt: 1,
                gap: 2,
                padding: 2,
                borderRadius: "16px",
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
            }}>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'end', gap: 5 }}>
                    <Box>
                        <Typography textAlign="end">{t("order_page.Total unit")}</Typography>
                        <Typography textAlign="end">{t("order_page.Subtotal")}</Typography>
                        <Typography textAlign="end">{t("order_page.Discount from promotion")}: </Typography>

                        <Typography textAlign="end">{t("order_page.Discount from coupon")}: </Typography>

                        <Typography textAlign="end">{t("order_page.Taxes")}</Typography>
                        <Typography textAlign="end">{t("order_page.Delivery fee")}</Typography>
                        <Typography textAlign="end" fontWeight="bold">{t("order_page.Total")}</Typography>
                    </Box>
                    <Box>
                        <Typography textAlign="end">{numberFormat(calculateOrderProductUnitByCarts(selectedData?.carts))} {t("order_page.units")}</Typography>
                        <Typography textAlign="end">{numberFormat(selectedData?.totalNomalPrice)} {t("Kip")}</Typography>
                        <Typography textAlign="end" color="red">- {numberFormat(selectedData?.totalDiscountPriceForPromotion)} {t("Kip")}</Typography>
                        <Typography textAlign="end" color="red">- {numberFormat(selectedData?.totalDiscountPriceForCoupon)} {t("Kip")}</Typography>
                        <Typography textAlign="end">{numberFormat(selectedData?.totalVatPrice)} {t("Kip")}</Typography>
                        <Typography textAlign="end">{numberFormat(selectedData?.deliveryFee)} {t("Kip")}</Typography>
                        <Typography textAlign="end" fontWeight="bold">{numberFormat(selectedData?.totoalWithDeliveryFee)} {t("Kip")}</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CardCustomer